// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Bnkngf_1kEoB5voPTIIX{align-items:center;max-width:100%;display:flex}.LUuI95sseYMTcKJp82z5 .xiqwiELHJYsH0vkBT18r{margin-left:8px}.LUuI95sseYMTcKJp82z5 .ydPQVtNzlHAS9z05EQ7F{margin-left:6px}.xiqwiELHJYsH0vkBT18r{color:var(--content-primary-primary);max-width:150px;margin-right:6px}.ydPQVtNzlHAS9z05EQ7F{flex-shrink:0;margin-right:8px}.QFnd02_Hwcy4SQukykuV{color:var(--content-primary-primary)}.YsGrmmdWR2wmo5NgAIZT{height:auto;min-height:32px}.VF9u6DwjzvELtkLVqE5T{background:var(--background-brand-subtle-primary);color:var(--content-primary-tertiary)}.hAT2EMl5icEmAXsvaENp{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Bnkngf_1kEoB5voPTIIX`,
	"wrap--checkbox": `LUuI95sseYMTcKJp82z5`,
	"wrapCheckbox": `LUuI95sseYMTcKJp82z5`,
	"title": `xiqwiELHJYsH0vkBT18r`,
	"icon": `ydPQVtNzlHAS9z05EQ7F`,
	"number": `QFnd02_Hwcy4SQukykuV`,
	"dropdown": `YsGrmmdWR2wmo5NgAIZT`,
	"highlighter": `VF9u6DwjzvELtkLVqE5T`,
	"highlighter--number": `hAT2EMl5icEmAXsvaENp`,
	"highlighterNumber": `hAT2EMl5icEmAXsvaENp`
};
export default ___CSS_LOADER_EXPORT___;
